<template>
    <b-modal :active.sync="isActive"
             has-modal-card full-screen >
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title"> {{ClassificationOfDiseases}}
                    <span class="tag is-warning">  {{idlab}}</span>

                </p>


                <button class="delete" aria-label="close"   @click="closeBtn" ></button>
            </header>

            <section class="modal-card-body">
                <p class="modal-card-title">
                    <b-button type="is-success"
                              icon-right="plus"
                              @click="addCode" > </b-button>
                </p>
                <b-table         :data="dataTempCompute"
                                 bordered
                                 striped
                                 narrowed
                                 hoverable
                                 focusable
                                 mobile-cards
                >
                    <!--                    {"ID":"TMTEp8Cics","level1ID":"11e41c985f74","level1Name":"Neoplasia",
                       "level2ID":"7bb75cecd608","level2Name":"Skin and soft tissues","level3ID":"e0674335452c",
                       "level3Name":"Nail (Subungual)","level4ID":"9edfd4f46a8c","level4Name":"Subungual malignant melanoma",
                       "level5ID":"","level5Name":"","labDiseasecodeAccurateID":1,"labDiseasecodeAccurateName":"10%","comment":"tytttt","unClassifiedCodes":"123"}-->
                    <b-table-column   label="Chapter" v-slot="props">
                        {{ props.row.id_run }}
                    </b-table-column>
                    <b-table-column   label="Chapter" v-slot="props">
                        {{ props.row.level1Name }}
                    </b-table-column>
                    <b-table-column   label="Body System" v-slot="props">
                        {{ props.row.level2Name }}
                    </b-table-column>
                    <b-table-column   label="Organ/Tissue" v-slot="props">
                        {{ props.row.level3Name }}
                    </b-table-column>
                    <b-table-column   label="Character/Subcategories" v-slot="props">
                        {{ props.row.level4Name }}
                    </b-table-column>
                    <b-table-column   label="Extensions" v-slot="props">
                        {{ props.row.level5Name }}
                    </b-table-column>
                    <b-table-column  label="Unclassified Descriptions" v-slot="props">
                        {{ props.row.unClassifiedCodes }}
                    </b-table-column>
                    <b-table-column  label="%" v-slot="props">
                        {{ props.row.labDiseasecodeAccurateName }}
                    </b-table-column>
                    <b-table-column  label="Remark" v-slot="props">
                        {{ props.row.comment }}
                    </b-table-column>
                    <b-table-column  label="#" v-slot="props" >
                        <b-button type="is-danger"
                                  icon-right="delete"
                                  @click="deleteCode( props.row.ID)" ></b-button>
                    </b-table-column>

                </b-table>
            </section>
            <footer class="modal-card-foot">
                <!--                <button class="button is-danger"   @click="closeBtn" >Cancel</button>-->
                <b-button type="is-danger"
                          icon-right="close"
                          @click="closeBtn" >Cancel</b-button>
                <b-button type="is-success"
                          icon-right="cloud-upload"
                          @click="saveBtn" >Save </b-button>
            </footer>
            <SelectDiseaseCode v-if="isModalSelectDiseaseCode"
                               @close="closeSelectDiseaseCode"
                               @closeWithChange="closeSelectDiseaseCode_WithChange" />

        </div>
    </b-modal>

</template>

<script>
    import globalconst from "../../../mixins/globalconst";
    import SelectDiseaseCode from "../SelectDiseaseCode";
    import {mapState} from "vuex";
    import axios from "axios";
    import { getBaseURLforBackEnd , getConfigAxios   }  from '@/utils.js'


    export default {
        name: "PlusSelectDiseaseCode",
        components:{
            SelectDiseaseCode
        },
        computed:{
            ...mapState({
                clientIP : state => state.master_data.clientIP,
                access_token: state => state.master_data.access_token,
            }),
            dataTempCompute: function () {
                var idRun = 0
                return this.dataTemp.map(dat=>{
                    idRun +=1
                    return  {
                             id_run : idRun,
                             ID : dat.ID,
                             level1ID : dat.level1ID,
                             level1Name : dat.level1Name,
                             level2ID : dat.level2ID,
                             level2Name : dat.level2Name,
                             level3ID : dat.level3ID,
                             level3Name : dat.level3Name,
                             level4ID : dat.level4ID,
                             level4Name : dat.level4Name,
                             level5ID : dat.level5ID,
                             level5Name : dat.level5Name,
                             labDiseasecodeAccurateID : dat.labDiseasecodeAccurateID,
                             labDiseasecodeAccurateName : dat.labDiseasecodeAccurateName,
                             comment : dat.comment,
                             unClassifiedCodes : dat.unClassifiedCodes}

                })
            }
        },
        mixins:[globalconst],
        props:{
            idlab : String,
            isShowing : Boolean,
        },
        data(){
            return {
                isActive : true,
                isModalSelectDiseaseCode : false,
                dataTemp : []
                    // {"ID":"TMTEp8Cics","level1ID":"11e41c985f74","level1Name":"Neoplasia","level2ID":"7bb75cecd608","level2Name":"Skin and soft tissues","level3ID":"e0674335452c","level3Name":"Nail (Subungual)","level4ID":"9edfd4f46a8c","level4Name":"Subungual malignant melanoma","level5ID":"","level5Name":"","labDiseasecodeAccurateID":1,"labDiseasecodeAccurateName":"10%","comment":"tytttt","unClassifiedCodes":"123"}
            }
        },
        methods:{
            //
            closeSelectDiseaseCode(){
                this.isModalSelectDiseaseCode =false
            },
            closeSelectDiseaseCode_WithChange(dataToSave){
                // console.log(dataToSave)
                this.dataTemp.push(dataToSave)
                this.isModalSelectDiseaseCode =false
            },
            //
            deleteCode(_id){
                // console.log(_id)
                const member = this.dataTemp.find(member => member.ID === _id )
                const memberIndex = this.dataTemp.indexOf(member)
                this.dataTemp.splice(memberIndex,1)
            },
            saveBtn(){
                //************************************************
                //************************************************
                //************************************************

                var tmp ={
                    id_grp_icd10 : [],
                    id_accurate : [] ,
                    arrunclassifiedcode : [],
                    arrcommenttxt : []
                }

                for(var j =0;j<this.dataTemp.length;j++) {

                    if (this.dataTemp[j].level5ID === null)  {
                        this.dataTemp[j].level5ID = ""
                    }
                    if (this.dataTemp[j].level4ID === null)  {
                        this.dataTemp[j].level4ID = ""
                    }
                    if (this.dataTemp[j].level3ID === null)  {
                        this.dataTemp[j].level3ID = ""
                    }
                    if (this.dataTemp[j].level2ID === null )  {
                        this.dataTemp[j].level2ID = ""
                    }
                    if (this.dataTemp[j].level1ID === null ) {
                        this.dataTemp[j].level1ID = ""
                    }


                }

                // console.log(this.dataTemp)
                for(var i =0;i<this.dataTemp.length;i++) {

                    if (this.dataTemp[i].level5ID !== "") {
                        tmp.id_grp_icd10.push( this.dataTemp[i].level5ID)
                    } else if (this.dataTemp[i].level4ID !== "")  {
                        tmp.id_grp_icd10.push( this.dataTemp[i].level4ID)
                    } else if (this.dataTemp[i].level3ID !== "")  {
                        tmp.id_grp_icd10.push( this.dataTemp[i].level3ID)
                    } else if (this.dataTemp[i].level2ID !== "")  {
                        tmp.id_grp_icd10.push(  this.dataTemp[i].level2ID)
                    } else if (this.dataTemp[i].level1ID !== "") {
                        tmp.id_grp_icd10.push( this.dataTemp[i].level1ID)
                    }else {
                        tmp.id_grp_icd10.push(null)
                    }



                    tmp.id_accurate.push(this.dataTemp[i].labDiseasecodeAccurateID)
                    tmp.arrunclassifiedcode.push(this.dataTemp[i].unClassifiedCodes)
                    tmp.arrcommenttxt.push(this.dataTemp[i].comment)
                }


                 const datTo = {
                     idlab : this.idlab,
                     dat : tmp,
                     ipaddress : this.clientIP
                 }

                // console.log(JSON.stringify(datTo))
                const vm = this
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/newinsertdiseasecodeplus`, datTo , getConfigAxios())
                    .then(()=>{
                        vm.isFullScreenSearching = false
                        vm.$buefy.toast.open({
                            message: 'Update data completely!',
                            type: 'is-success'
                        })
                        vm.$emit("closePlusSelectDiseaseCode_WithChange")
                    })
                    .catch(err=>{
                        // console.log("err")e.response.data.msg

                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err.response.data.msg}` ,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })


                        if (err.response && err.response.status === 401) {
                            vm.$router.push('/login')
                        }
                    })

                //************************************************
                //************************************************
                //************************************************


            },
            closeBtn(){
               this.$emit("closePlusSelectDiseaseCode")
            },
            addCode(){
                this.isModalSelectDiseaseCode = true
            }
        },
        watch:{
            isShowing:{
                immediate: true,
                handler: function (val) {
                    if(val){
                        // console.log("showing PlusSelectDiseaseCode")
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>